import { render, staticRenderFns } from "./modZonaPagoClinica.vue?vue&type=template&id=2908f039"
import script from "./modZonaPagoClinica.vue?vue&type=script&lang=js"
export * from "./modZonaPagoClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports